import request from '@/utils/request'

export function fetchAppList (query) {
  return request({
    url: '/auth/api/app/index',
    method: 'get',
    params: query
  })
}

export function fetchApp (id) {
  return request({
    url: '/auth/api/app/view',
    method: 'get',
    params: { id }
  })
}

export function createApp (data) {
  return request({
    url: '/auth/api/app/insert',
    method: 'post',
    data
  })
}

export function updateApp (data) {
  return request({
    url: '/auth/api/app/update',
    method: 'post',
    data
  })
}

export function deleteApp (id) {
  return request({
    url: '/auth/api/app/delete',
    method: 'post',
    params: { id }
  })
}

export function fetchAppConfigList (query) {
  return request({
    url: '/auth/api/app_config/index',
    method: 'get',
    params: query
  })
}

export function fetchAppConfig (id) {
  return request({
    url: '/auth/api/app_config/view',
    method: 'get',
    params: { id }
  })
}

export function createAppConfig (data) {
  return request({
    url: '/auth/api/app_config/insert',
    method: 'post',
    data
  })
}

export function updateAppConfig (data) {
  return request({
    url: '/auth/api/app_config/update',
    method: 'post',
    data
  })
}

export function deleteAppConfig (id) {
  return request({
    url: '/auth/api/app_config/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/api/app.js